import {
    CHANGE_PROGRESS,
    SET_LOGIN_ERRORS,
    FULLFILL_USER,
    CLEAR_STATE
} from './available';

export default {
    [FULLFILL_USER] (state, user) {
        state.user = user
    },
    [CLEAR_STATE] (state) {
        state.user = {}
        state.loginErrors = {}
    },
    [CHANGE_PROGRESS] (state, value) {
        state.progress = value
    },
    [SET_LOGIN_ERRORS] (state, errors) {
        state.loginErrors = {
            email: errors.email,
            password: errors.password,
            common: errors.common
        }
    }
}
